module.exports = __webpack_public_path__ + "static/012-723408307c11500043fa510550c8ccd8.jpg";